const LabelMapper = {
  assets: 'assets',
  cash: 'Cash',
  derivativeFinancialAssets: 'Derivative financial assets',
  ppe: 'Property, plant and equipment',
  receivables: 'Receivables',

  entityType: 'Entity type',

  expenses: 'expenses',
  assetImpairment: 'Asset impairment',
  assetDepreciation: 'Asset depreciation',
  transmissionChargesAndElectricityPurchases:
    'Transmission charges and electricity purchases',
  fuelAndMaterials: 'Fuel and materials',
  employeeBenefitsExpense: 'Employee benefits expenses',

  liabilities: 'liabilities',
  employeeBenefits: 'Employee benefits',
  borrowings: 'Borrowings',
  provisions: 'Provisions',
  payables: 'Payables',
  derivativeFinancialLiabilities: 'Derivative financial liabilities',

  name: 'name',

  revenue: 'revenue',
  electricityGeneration: 'Electricity generation',
  networkFees: 'Network fees',
  retailElectricity: 'Retail electricity',
  serviceCharges: 'Service charges',

  shareholderReturns: 'Shareholder returns',
  taxEquivalent: 'Tax equivalent',
  dividendParticipationReturn: 'Dividend/ participation return',

  other: 'Other',

  entityCapacity: 'Generation capacity',
  facilitiesPerEntity: 'Power stations',

  EEQ: 'Ergon Energy Queensland',
  EQL: 'Energy Queensland (Energex and Ergon)',
};

const EntityLabelMapper = {
  plural: {
    'Energy generator': 'Energy generators',
    'Energy transmitter and distributor':
      'Energy transmitters and distributors',
    'Energy retailer': 'Energy retailers',
  },
  singular: {
    'Energy generator': 'Energy generator',
    'Energy transmitter and distributor': 'Energy transmitter and distributor',
    'Energy retailer': 'Energy retailer',
  },
};

export const entityLabelMatcher = (str, pluralOrSingular) => {
  if (str.includes('Other')) {
    str = 'Other Entities';
  }
  const label =
    pluralOrSingular === 'plural'
      ? EntityLabelMapper.plural[str]
      : EntityLabelMapper.singular[str];
  if (!label) {
    throw Error('Missing label for: ' + str);
  }
  return label;
};

export const labelMatcher = (str) => {
  const label = LabelMapper[str];
  if (!label) {
    return str;
  }
  return label;
};



// WEBPACK FOOTER //
// ./src/helpers/label-mapper.js